<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="''"></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_block"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				Provide Affordable, Use-friendly & Precision Diagnostic Products for theWorld
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="search_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="search_main">
							<div class="search_el">
								<van-icon name="search" size="20px" color="#999999" class="icon_left" />
								<input v-model="searchVal" ref="searchDom" :placeholder="$t('nav.text1')" @keyup.enter="searchClick" />
								<van-icon name="down" size="22px" color="#A50073" class="icon_right" @click="searchClick" />
							</div>
						</div>
					</div>
					<div v-if="searchList.length > 0">
						<div class="list_box">
							<div class="tit_box"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="tit">Results</div>
								<div class="txt">Total: {{ total }}</div>
							</div>
							<div class="list_box_main">
								<div v-for="(value, index) in searchList" :key="index" class="list_el"
									data-aos="fade-up"
									data-aos-duration="400"
									data-aos-delay="100"
									data-aos-offset="0"
									data-aos-once="true"
									@click="goInfo(value)"
								>
									<div class="tips">{{ value.leixing == 'Products' ? 'Product' : 'News' }}</div>
									<div class="left">
										<img :src="webUrl + value.thumb" />
									</div>
									<div class="right">
										<div class="tit">{{ value.leixing == 'Products' ? value.name : value.title }}</div>
										<div class="txt">{{ value.content }}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="page_box"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<el-pagination
								:small="false"
								background
								layout="prev, pager, next"
								:total="total"
								:page-size="10"
								@current-change="pageChange"
							>
							</el-pagination>
						</div>
					</div>
					<div v-else
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<van-empty image="search" description="No Data" />
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { UPURL } from '@/util/util'
import { searchList } from '@/api/public'
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			searchVal: '',
			page: 1,
			total: 0,
			searchList: [],
			webUrl: UPURL
		}
	},
	created(){
		let that = this;
		if(that.$route.query.search) {
			that.searchVal = that.$route.query.search;
			that.getList();
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击查看详情
		goInfo(value) {
			let that = this;
			if(value.leixing == 'Products') {
				let routeData = that.$router.resolve({name: "ProductInfo", params: { productInfoId: value.id + '.html' } });
				window.open(routeData.href, '_blank');
			}else {
				let routeData = that.$router.resolve({name: "NewsInfo", params: { newInfoId: value.id + '.html' } });
				window.open(routeData.href, '_blank');
			}
		},
		//点击搜索
		searchClick() {
			let that = this;
			if(that.searchVal) {
				that.getList();
			}else {
				that.$toast('Please enter keywords');
			}
		},
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList();
		},
		//搜索
		getList() {
			let that = this;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			searchList({
				page: that.page,
				page_size: 10,
				keyword: that.searchVal,
				language: sessionStorage.getItem('lang')
			}).then(res => {
				that.searchList = res.data.data;
				that.total = res.data.total;
				that.$toast.clear();
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		background: url(../../assets/img_public/search/block_bg.webp) no-repeat 100% 100%;
		background-size: cover;
		.block_1_main{
			width: 1264px;
			margin: 0 auto;
			padding: 20px 0 60px 0;
			.page_box{
				padding-bottom: 50px;
				text-align: center;
			}
			.list_box{
				.list_box_main{
					padding-top: 50px;
					.list_el{
						position: relative;
						display: flex;
						align-items: center;
						margin-bottom: 40px;
						padding: 34px 50px 20px 50px;
						border-radius: 8px;
						background-color: #ffffff;
						cursor: pointer;
						.tips{
							position: absolute;
							right: 20px;
							top: 15px;
							font-size: 14px;
							padding: 6px 16px 4px 16px;
							border-radius: 16px;
							background-color: #efefef;
							color: #A50073;
						}
						.right{
							flex: 1;
							padding-left: 30px;
							.txt{
								margin-top: 10px;
								font-size: 16px;
								color: #999999;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								-webkit-box-orient: vertical;
							}
							.tit{
								font-size: 20px;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 1;
								-webkit-box-orient: vertical;
							}
						}
						.left{
							width: 150px;
							img{
								width: 100%;
							}
						}
					}
				}
				.tit_box{
					.txt{
						padding-top: 6px;
						font-size: 16px;
					}
					.tit{
						font-size: 30px;
					}
				}
			}
			.search_box{
				width: 100%;
				.search_main{
					padding: 40px 0 40px 0;
					.search_el{
						width: 100%;
						margin: 0 auto;
						position: relative;
						.icon_close{
							position: absolute;
							right: -100px;
							top: -35px;
							cursor: pointer;
						}
						.icon_left{
							position: absolute;
							top: 16px;
						}
						.icon_right{
							position: absolute;
							top: 16px;
							right: 0;
							transform: rotate(-90deg);
							cursor: pointer;
						}
						input{
							width: 100%;
							height: 60px;
							line-height: 60px;
							font-size: 20px;
							border: none;
							border-bottom: 1px solid #A50073;
							color: #A50073;
							padding: 0 38px;
							background-color: transparent;
						}
					}
				}
			}
		}
	}
	.banner_block{
		width: 100%;
		height: 110px;
		line-height: 110px;
		background: linear-gradient( 90deg, #A50073 0%, #C7007E 49%, #A50073 100%);
		text-align: center;
		color: #ffffff;
		font-size: 22px;
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>